import 'consumerweb-shim';
import 'adsinterceptor';
import PropTypes from 'prop-types';
import { Header, Footer } from 'marketing-components';
import React from 'react';
import ReactDOM from 'react-dom';
import uniq from 'lodash/uniq';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Row, Col } from 'react-bootstrap';
import MediaQuery from 'react-responsive';
import { DataContext } from '../../lib/context';
import {
  BodyText,
  Link,
  Button,
  HeadingText,
  CaptionText,
  Badge,
  Container,
  WebsiteIcon,
  ArrowLeftIcon,
  InformationIcon,
  PAYPAL_THEME,
  v2neutral300,
  v2grey600,
  AddIcon,
  CausesIcon,
  IconButton,
} from '@paypalcorp/pp-react';
import { ThemeProvider } from '@emotion/react';
import * as analytics from '../../lib/analytics';
import CharityLogo from '../../components/charityLogo';
import DonateBox from '../../components/donateBox';
import Benefits from '../../components/benefits/benefits';
import HubSocialShare from '../../components/HubSocialShare';
import CheckoutError from '../../components/checkoutError';
import SetPreferredHeart from '../../components/SetPreferredHeart/SetPreferredHeart';
import Spinner from '../../components/spinner/Spinner';
import content from '../../lib/i18n';
import SheetTrigger from '../../components/SheetTrigger';

import styles from './hub-npo.less';
import { getType, isPPGF } from '../../lib/charity';
import utils from '../../lib/utils';
import DonationTerms from '../../components/donation-terms';

import classNames from 'classnames';

import {
  HUB_PAGE_GROUP,
  HUB_PAGE_PROFILE_PAGE,
} from '../../lib/fptiTrackingVariables';
import glamorous from 'glamorous';
import CopyButton from '../../components/CopyButton/CopyButton';
import {
  getHeaderClassName,
  getHeaderProps,
  getIsLoggedIn,
} from '../../lib/header';
import NpoFundraiserList from '../../components/npoFundraisersList/npoFundraisersList';
import { NoSearchResults } from '../../redesignComponents/noSearchResult/noSearchResults';
import DonateButton from '../../components/donateButton';
import { PPGF_ENROLLED } from '../../../../config/constant';

const i18n = content('hubProfilePage');

if (window.PAYPAL && window.PAYPAL.analytics) {
  window.PAYPAL.analytics.startClientErrorTracking();
}

const LegalTerms = glamorous(CaptionText)({
  '& a': {
    color: PAYPAL_THEME.sysColorSecondaryMain,
    fontFamily: PAYPAL_THEME.sysTypographyBodyStrongFamily,
  },
});

const SocialShareContainer = glamorous.div({
  '@media(max-width: 500px)': {
    margin: '16px',
  },
  '@media(min-width: 500px)': {
    margin: '0px',
  },
});

const LinkStyle = {
  padding: '10px 12px',
  borderRadius: '30px',
  backgroundColor: PAYPAL_THEME.sysColorBackgroundMain,
  height: '48px',
  width: '48px',
  margin: '0px 16px 0px 0px',
  color: PAYPAL_THEME.sysColorPrimaryMain,
  textAlign: 'center',
};

const charityShare = {
  backgroundColor: PAYPAL_THEME.sysColorBackgroundMain,
  padding: '16px',
  display: 'flex',
  overflowWrap: 'break-word',
};

const contentDisclaimerTextPPGF = {
  color: PAYPAL_THEME.sysColorBackgroundMediumContrast,
  marginBottom: '34px',
};

const contentDisclaimerText = {
  color: PAYPAL_THEME.sysColorBackgroundMediumContrast,
  margin: '24px 0px 34px 0px',
};

const unenrolledDisclaimerContainer = {
  display: 'flex',
  boxSizing: 'border-box',
  borderRadius: '0.75rem',
  padding: '16px',
  marginBottom: '34px',
  backgroundColor: PAYPAL_THEME.sysColorBackgroundMain,
};

const unenrolledDisclaimerIcon = {
  color: PAYPAL_THEME.sysColorBackgroundMediumContrast,
};

let analyticsData = {};

class Page extends React.Component {
  static propTypes = {
    csrf: PropTypes.string,
    description: PropTypes.string,
    website_url: PropTypes.string,
    mission_area: PropTypes.array,
    resources: PropTypes.object,
    states: PropTypes.object,
    address: PropTypes.object,
    campaigns: PropTypes.array,
    elmo: PropTypes.object,
  };

  static childContextTypes = {
    csrf: PropTypes.string,
  };

  constructor(props, context) {
    super(props, context);
    var initialState = {
      fptiInfo: {
        pgrp: HUB_PAGE_GROUP,
        page: HUB_PAGE_PROFILE_PAGE,
      },
      heartSelected: props.isThisCharityTheirPreferred,
      isPreferredCharitySwitch: props.isThisCharityTheirPreferred === undefined,
      isMobile: false,
      heartError: false,
      showToastPreferredMessage: this.props.showToastPreferredMessage,
    };
    this.state = initialState;

    analyticsData = {
      e: 'im',
      product: 'dw_giving',
      flow: 'PP_FUNDRAISING',
      tile_id: 'charity profile page',
      event_source: analytics.getEventSource(
        /Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)
      ),
      account_type: analytics.getAccountType(this.props.authState),
      acct_cntry: this.props.contentCountry,
      charityname: this.props.name,
      crid: this.props.nonprofit_id,
    };
  }

  componentDidMount() {
    if (/Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.setState({
        isMobile: true,
      });
    }

    // to replace the default /signin href from marketing header
    // we need it to go back to npo page
    const marketingULButton = document.getElementById('ul-btn') || {};
    marketingULButton.href = this.props.unifiedLoginURL;

    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_DETAIL_SCREEN_SHOWN,
      analyticsData
    );
  }

  parseFPTIInfo = (fptiData) => {
    const nameValues = [];
    const pairs = decodeURIComponent(fptiData).split('&');
    let i;
    for (i = 0; i < pairs.length; i++) {
      const parts = pairs[i].split('=');
      nameValues[parts[0]] = parts[1];
    }
    return nameValues;
  };

  getChildContext() {
    return {
      csrf: this.props.csrf,
    };
  }

  recordUnenrolledBannerShown = () => {
    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_DETAIL_UNENROLLED_CHARITY_BANNER_SHOWN,
      analyticsData
    );
  };

  recordUnenrolledLearnMorePressed = () => {
    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_DETAIL_UNENROLLED_CHARITY_LEARN_MORE_PRESSED,
      Object.assign({}, analyticsData, {
        e: 'cl',
      })
    );
  };

  recordFundraiserStartPressed = () => {
    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_DETAIL_SUPPORTING_FUNDRAISER_START_PRESSED,
      Object.assign({}, analyticsData, {
        e: 'cl',
      })
    );
  };

  recordSupportingFundraiserModuleShown = () => {
    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_DETAIL_SUPPORTING_FUNDRAISER_MODULE_SHOWN,
      Object.assign({}, analyticsData, {
        e: 'cl',
      })
    );
  };

  clickCopy = () => {
    analytics.trackLink(
      'overlaycopybutton',
      fptiInfo.pgrp,
      fptiInfo.page,
      'link'
    );
  };

  handleAnalyticsCategory = (category) => {
    analytics.trackLinkWithData(
      'CategoryClicked',
      this.state.fptiInfo.pgrp,
      this.state.fptiInfo.page,
      { category },
      'link'
    );
  };

  handleAnalyticsWebLink = () => {
    analytics.trackLink(
      'WebsiteLink',
      this.state.fptiInfo.pgrp,
      this.state.fptiInfo.page,
      'link'
    );
  };

  renderError = () => {
    if (this.props.donationInfo && this.props.donationInfo.donated === 0) {
      return (
        <CheckoutError
          i18n={i18n}
          fptiInfo={this.state.fptiInfo}
          cdnHost={this.props.cdnHost}
        />
      );
    }
  };

  renderFooter = () => {
    const {
      content: { content: footerContent, config = {} },
    } = JSON.parse(document.getElementById('data-footer').innerHTML);
    const { localeCountry } = footerContent;

    return (
      <Footer
        config={config}
        content={footerContent}
        localeCountry={localeCountry}
      />
    );
  };

  renderHeader = () => {
    const dataHeader = JSON.parse(
      document.getElementById('data-header').innerHTML
    );

    const props = getHeaderProps(this.props.authState, dataHeader.content);

    return (
      <div className={getHeaderClassName('v3')}>
        <Header {...props} />
      </div>
    );
  };

  renderDonationTerms = () => {
    const type = getType(this.props.charity);
    const charityContent = this.props.charityContent;

    return (
      <div className={styles.donationTermsStyle}>
        <DonationTerms
          i18n={i18n}
          charity={charity}
          type={type}
          donationTerms={charityContent.donationTerms}
          // join={true}
        />
      </div>
    );
  };

  setPreferredFetch = () => {
    this.setState(
      {
        isLoading: true,
        heartError: false,
      },
      () => {
        fetch('/fundraiser/setPreferredCharity', {
          method: 'POST',
          body: JSON.stringify({
            _csrf: this.props.csrf,
            npid: this.props.nonprofit_id,
            setPreferred: !this.state.heartSelected,
          }),
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (response.status >= 400) {
              this.setState({
                isLoading: false,
                heartError: true,
                showToastPreferredMessage: true,
              });
            } else {
              return response.json();
            }
          })
          .then((data) => {
            const { setPreferredSuccess } = data;
            if (setPreferredSuccess) {
              this.setState({
                isLoading: false,
                // This validation was added because if there is a charity already selected as favorite once the users
                // reaches the npo page the isPreferredCharitySwitch will be setted and if this id is different to the
                // charity that is displayed on the page the corresponding message for this scenario will be displayed every
                // time the user sets this one as favorite until he refreshes the page
                isPreferredCharitySwitch: !this.state.heartSelected
                  ? this.state.isPreferredCharitySwitch
                  : false,
                heartSelected: !this.state.heartSelected,
                showToastPreferredMessage: true,
              });
              analytics.trackLinkWithData(
                'npoHeartClicked',
                this.state.fptiInfo.pgrp,
                this.state.fptiInfo.page,
                {
                  npoHeartSelected: this.state.heartSelected,
                  crid: this.props.nonprofit_id,
                },
                'link'
              );
            } else {
              this.setState({
                isLoading: false,
                heartError: true,
                showToastPreferredMessage: true,
              });
            }
          });
      }
    );
  };

  getBackgroundURL = () => {
    if (
      this.props.charity_background_images &&
      this.props.charity_background_images.length > 0
    ) {
      return {
        url: this.props.charity_background_images[
          this.props.charity_background_images.length - 1
        ].image_url,
        class: styles['npo-charity-hero'],
      };
    }
    return {
      url: `https://${this.props.cdnHost}/paypal-ui/illustrations/scenic/svg/blue-waves.svg`,
      class: 'cause-charity-hero',
    };
  };

  render() {
    const npid = this.props.nonprofit_id;
    const charityContent = this.props.charityContent;
    const formUrl = this.props.coBrand + 'charity/' + npid;
    const isLoggedIn = getIsLoggedIn(this.props.authState);
    const isMerchant = this.props.userType === 'BUSINESS';
    const unifiedLoginURL = this.props.unifiedLoginURL;
    const charityType = get(charity, 'charity_type', 'PPGF').toUpperCase();
    const isUnEnrolled =
      charityType === 'PPGF_UNENROLLED' ||
      charityType === 'EXTERNAL' ||
      charityType === 'GUIDESTAR';
    const npoFbDesc1 = i18n('label.social-profile-description1');
    const npoFbDesc2 = i18n('label.social-profile-description2');
    const fbDesc = npoFbDesc1.concat(' ', charity.name, ' ', npoFbDesc2);

    const setPreferred =
      isCountrySetPreferredSupported && !isUnEnrolled ? (
        <>
          {isMerchant ? null : (
            <>
              {this.state.isLoading ? (
                <div className={styles['flex-center']}>
                  <Spinner size='md' />
                </div>
              ) : (
                <>
                  <Link
                    data-nemo={!isLoggedIn ? 'npo-heart-link' : undefined}
                    href={
                      !isLoggedIn
                        ? utils.getUnifiedLoginURL(unifiedLoginURL, [
                            {
                              key: 'setPreferred',
                              value: 'true',
                            },
                          ])
                        : undefined
                    }
                    onClick={() => {
                      if (isLoggedIn) {
                        this.setPreferredFetch();
                      }
                    }}
                    style={LinkStyle}
                  >
                    <SetPreferredHeart
                      selected={this.state.heartSelected}
                      charityName={this.props.charity.name}
                      nonprofitId={this.props.charity.nonprofit_id}
                      showToastPreferredMessage={
                        this.state.showToastPreferredMessage
                      }
                      isPreferredCharitySwitch={
                        this.state.isPreferredCharitySwitch
                      }
                      i18n={i18n}
                      hasError={this.state.heartError}
                      errorMessage={i18n('label.setPref-errorAlert')}
                    />
                  </Link>
                </>
              )}
            </>
          )}
        </>
      ) : null;

    let categories;
    if (Array.isArray(this.props.cause_area)) {
      const causeAreaIDs = uniq(this.props.cause_area.map((ca) => ca.id));
      categories = causeAreaIDs.map((id) => ({
        value: String(id),
        label: i18n(`label.category-${id}`),
      }));
    } else {
      categories = [];
    }

    let link = (
      <div style={{ display: 'flex', margin: '24px 0px' }}>
        {this.props.website_url && (
          <Link
            tabIndex='0'
            onClick={this.handleAnalyticsWebLink}
            target={'_blank'}
            href={this.props.website_url}
            style={LinkStyle}
            className={styles.linkStyle}
          >
            <WebsiteIcon
              style={{ color: PAYPAL_THEME.sysColorPrimaryMain }}
              role='link'
              aria-label={i18n('label.go-to-website')}
              size='lg'
              as='svg'
              className={styles.websiteicon}
            ></WebsiteIcon>
          </Link>
        )}
        {setPreferred}
      </div>
    );

    let ein;
    if (this.props.ein) {
      const einLabel = !isEmpty(charityContent.einLabel)
        ? `${i18n(charityContent.einLabel)} `
        : '';
      ein = (
        <BodyText as='p' size='md'>
          {einLabel}
          <span>{this.props.ein}</span>
        </BodyText>
      );
    }

    const address = this.props.address;
    const cityState = (
      <BodyText as='p' size='md'>
        {[address.city, address.state]
          .map((x) => (x || '').trim())
          .filter((x) => !!x)
          .join(', ')}
      </BodyText>
    );

    let source;
    if (charityContent.source && charityType !== PPGF_ENROLLED) {
      source = (
        <CaptionText as='p' size='md' style={{ margin: '24px 0 0' }}>
          {`${i18n(charityContent.sourceLabel)}`}&nbsp;
          <span>{i18n(charityContent.source)}</span>
        </CaptionText>
      );
    }

    const isDescription = !!this.props.description;
    const hiddenDescription =
      isUnEnrolled && this.props.charity.address.country_code === 'US';

    let title;

    if (isPPGF(this.props.charity_type)) {
      title = i18n('label.donate-with-ppgf');
    }

    let charityContentDisclaimer;

    if (!isUnEnrolled) {
      charityContentDisclaimer = (
        <div style={{ marginTop: '24px' }}>
          <CaptionText
            style={
              isPPGF(this.props.charity_type)
                ? contentDisclaimerTextPPGF
                : contentDisclaimerText
            }
          >
            {i18n('label.charity-content-disclaimer')}
          </CaptionText>
        </div>
      );
    }

    let unenrolledDisclaimer;

    if (this.props.charity.address.country_code === 'US' && isUnEnrolled) {
      unenrolledDisclaimer = (
        <div style={unenrolledDisclaimerContainer}>
          <div style={unenrolledDisclaimerIcon}>
            <InformationIcon size='xs' />
          </div>
          <div className={styles.unenrolledDisclaimer}>
            <BodyText className={styles.unenrolledDisclaimerText}>
              {i18n('label.unenrolled-disclaimer')}
            </BodyText>
            <Link
              target={'_blank'}
              href={i18n('label.unenrolled-policies-href')}
              onClick={this.recordUnenrolledLearnMorePressed}
            >
              {i18n('label.unenrolled-learn-more')}
            </Link>
          </div>
        </div>
      );
      this.recordUnenrolledBannerShown();
    }

    // TODO: ln 465 Add to localization
    const about = (
      <Col>
        <div style={{ padding: '0px 16px 16px 16px' }}>
          <BodyText as='p' size='md'>
            {title}
          </BodyText>
          <HeadingText size='lg'>{this.props.name}</HeadingText>
          <div
            style={{
              padding: `${isDescription ? '24px 0px 12px 0px' : '24px 0px'}`,
            }}
          >
            {categories.map((category, categoryIndex) => {
              return (
                <Badge
                  style={{
                    borderRadius: '8px',
                    marginRight: '8px',
                    marginBottom: '8px',
                    height: '28px',
                  }}
                  key={categoryIndex}
                  type='feature'
                >
                  <Link
                    onClick={this.handleAnalyticsCategory.bind(
                      this,
                      category.value
                    )}
                    key={`np-${npid}-${categoryIndex}`}
                    href={`${this.props.resources.searchLink}?category=${category.value}`}
                  >
                    <CaptionText
                      style={{
                        color: PAYPAL_THEME.sysColorLinkContrast,
                      }}
                    >
                      {category.label}
                    </CaptionText>
                  </Link>
                </Badge>
              );
            })}
          </div>
          <div className={'aboutHelp'}>
            {cityState}
            {ein}
            {link}
            {isDescription && !hiddenDescription && (
              <BodyText as='p' size='md'>
                {this.props.description}
              </BodyText>
            )}
            {source}
            {charityContentDisclaimer}
            {unenrolledDisclaimer}
          </div>
        </div>
      </Col>
    );

    // DonateButton is for DNW flow use only
    const donateButton = (
      <Col>
        <DonateButton
          {...this.props}
          enable={true}
          i18n={i18n}
          formUrl={`${formUrl}/donate/createDnwToken`}
          charity={this.props.charity}
          fptiInfo={this.state.fptiInfo}
          isMobile={this.state.isMobile}
          label_alltocharity={i18n('label.all-to-charity')}
          cdnHost={this.props.cdnHost}
        />
      </Col>
    );

    // DonateBox is for checkout flow use only
    const donateBox = (
      <Col>
        <DonateBox
          {...this.props}
          enable={true}
          i18n={i18n}
          formUrl={`${formUrl}/xo/create`}
          charity={this.props.charity}
          fptiInfo={this.state.fptiInfo}
          isMobile={this.state.isMobile}
          label_alltocharity={i18n('label.all-to-charity')}
          cdnHost={this.props.cdnHost}
        />
        {this.renderDonationTerms()}
      </Col>
    );

    const donate = this.props.elmo.hasXoTrmt ? donateBox : donateButton;

    const benefits = (
      <>
        {isPPGF(allowedCharityType) && (
          <div
            className={'benefits-section'}
            style={{ backgroundColor: PAYPAL_THEME.sysColorBackgroundMain }}
          >
            <Benefits
              i18n={i18n}
              layout={'vertical'}
              percentToCharity={'100%'}
              cdnHost={this.props.cdnHost}
            />
          </div>
        )}
      </>
    );

    const pageUrl = `https://www.${this.props.domain}/${charity.address.country_code}/fundraiser/charity/${npid}`;
    // TODO: Add localization for "Copy"
    const social = (
      <SocialShareContainer>
        <div
          style={{
            borderColor: PAYPAL_THEME.sysColorUnselectedMain,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderRadius: '12px',
            padding: '14px',
            marginBottom: '48px',
          }}
        >
          <div className={styles['center-text']}>
            <BodyText style={{ marginBottom: '10px' }} as='p' size='md' strong>
              {i18n('label.spread-the-word')}
            </BodyText>
          </div>
          <HubSocialShare
            i18n={i18n}
            fbTitle={charity.name}
            url={pageUrl}
            fptiInfo={this.state.fptiInfo}
            fbDesc={fbDesc}
            cdnHost={this.props.cdnHost}
            style={{ marginTop: '16px' }}
          />
          <div style={charityShare}>
            <CopyButton
              clickCopy={this.clickCopy}
              copyText={i18n('label.copy')}
              text={pageUrl}
            />
          </div>
        </div>
      </SocialShareContainer>
    );

    const startFundraiserButton = (
      <Button
        secondary
        className={styles.startFundraiserButton}
        as='a'
        iconComponent={CausesIcon}
        onClick={this.recordFundraiserStartPressed}
        href={`/pools/c/create-crowdfunding/basics?npid=${npid}`}
      >
        {i18n('label.start-a-fundraiser')}
      </Button>
    );

    const ctaStartFundraiser = (
      <div className={styles.startFundraiserContainer}>
        <MediaQuery minWidth={1001}>{startFundraiserButton}</MediaQuery>
        <MediaQuery maxWidth={1000}>
          <IconButton
            buttonType='secondary'
            as='a'
            svgIconComponent={AddIcon}
            className={styles.startFundraiserIconButton}
            onClick={this.recordFundraiserStartPressed}
            href={`/pools/c/create-crowdfunding/basics?npid=${npid}`}
          >
            {i18n('label.start-a-fundraiser')}
          </IconButton>
        </MediaQuery>
      </div>
    );

    let fundraisers;
    if (
      (this.props.supportedProduct === 'all' ||
        this.props.supportedProduct === 'fundraisers') &&
      (charityType === 'PPGF_ENROLLED' ||
        charityType === 'DIRECT_MODEL_ENROLLED')
    ) {
      if (this.props.campaigns.length > 0) {
        this.recordSupportingFundraiserModuleShown();
        fundraisers = (
          <>
            <div className={styles.fundraisersTitleContainer}>
              <HeadingText size='sm' className={styles.fundraiserListHeader}>
                {i18n('label.fundraisers-supporting')}
              </HeadingText>
              {ctaStartFundraiser}
            </div>
            <div className={styles.fundraiserListContainer}>
              <NpoFundraiserList
                {...this.props}
                searchType='npoFundraisers'
                fptiInfo={this.state.fptiInfo}
                i18n={i18n}
              />
            </div>
          </>
        );
      } else {
        fundraisers = (
          <>
            <NoSearchResults
              header={i18n('label.support-with-fundraisers-title')}
              subHeader={
                isPPGF(charityType)
                  ? i18n('label.support-with-fundraisers-description')
                  : i18n(
                      'label.support-with-fundraisers-description-direct-model'
                    )
              }
              imageUrl='https://www.paypalobjects.com/paypal-ui/pictograms/multicolored/svg/donate.svg'
            />
            <div className={styles.noResultsCtaContainer}>
              {startFundraiserButton}
            </div>
          </>
        );
      }
    }

    const errorAlert = this.renderError();
    const backgroundImageProps = this.getBackgroundURL();

    return (
      <>
        {this.props.mppHeader && this.renderHeader()}
        <Container>
          <Row>
            <Col>
              <div className={styles['new-search-container']}>
                <Link
                  theme='v2'
                  href={'/fundraiser/hub'}
                  className={styles.fundraiserLink}
                  tabindex={-1}
                >
                  <Button tertiary iconComponent={ArrowLeftIcon}>
                    {i18n('label.new-search')}
                  </Button>
                </Link>
              </div>
            </Col>
          </Row>
          <MediaQuery minWidth={601}>
            <Row>
              <div
                className={classNames(
                  `${backgroundImageProps.class} ${styles.donateHeader}`
                )}
                style={{
                  background: `url(${backgroundImageProps.url}) no-repeat`,
                  backgroundSize: '100%',
                  position: 'relative',
                  backgroundPosition: 'center center',
                }}
              />
              <CharityLogo {...this.props} i18n={i18n} />
            </Row>
          </MediaQuery>
        </Container>
        <MediaQuery maxWidth={600}>
          <div
            className={styles.donateHeader}
            style={{
              background: `url(${backgroundImageProps.url}) no-repeat`,
              backgroundSize: '100%',
              position: 'relative',
              backgroundPosition: 'center center',
            }}
          />
          <CharityLogo {...this.props} i18n={i18n} />
        </MediaQuery>
        <MediaQuery minWidth={901}>
          <Container>
            <Row>
              <Col xs={7} md={7} lg={7}>
                {about}
              </Col>
              <Col xs={5} md={5} lg={5}>
                {donate}
                {social}
              </Col>
            </Row>
            {fundraisers}
          </Container>
          {benefits}
        </MediaQuery>
        <MediaQuery minWidth={601} maxWidth={900}>
          <Container>
            <Row>
              <Col xs={6} md={6} lg={6}>
                {about}
              </Col>
              <Col xs={6} md={6} lg={6}>
                {donate}
                {fundraisers}
                {social}
              </Col>
            </Row>
          </Container>
          {benefits}
        </MediaQuery>
        <MediaQuery maxWidth={600}>
          {about}
          {this.props.elmo.hasXoTrmt ? (
            <SheetTrigger
              TriggerComponent={
                <Button className={styles['sheet-trigger-button']}>{`${i18n(
                  'label.donate-button'
                )}`}</Button>
              }
              sheetProps={{
                title: i18n('label.donate-button'),
              }}
            >
              {donate}
            </SheetTrigger>
          ) : (
            <> {donate}</>
          )}

          {fundraisers}
          {social}
          {benefits}
        </MediaQuery>
        {/* {isPPGF(allowedCharityType) && (
            <FAQBanner fptiInfo={this.state.fptiInfo} i18n={i18n} />
          )} */}
        <Container>
          <div
            className={'npo-gifts-do-more'}
            style={{
              maxWidth: '100%',
            }}
          >
            <LegalTerms
              dangerouslySetInnerHTML={{
                __html: isPPGF(allowedCharityType)
                  ? i18n(charityContent.legalDisclaimer)
                  : i18n('label.legal-footer-default'),
              }}
              size='sm'
              as='p'
            />
          </div>
        </Container>
        {errorAlert}
        {this.props.mppFooter && this.renderFooter()}
      </>
    );
  }
}

const charity = JSON.parse(document.getElementById('charity-props').innerHTML);
const data = JSON.parse(document.getElementById('data-props').innerHTML);
const donationInfo = JSON.parse(
  document.getElementById('donation-info-props').innerHTML || '{}'
);
const states = JSON.parse(document.getElementById('states-props').innerHTML);
const amounts = JSON.parse(document.getElementById('amount-props').innerHTML);
const fptiInfo = JSON.parse(
  document.getElementById('data-fpti-info').innerHTML
);
const csrf = document.getElementById('data-csrf').innerHTML;
const coBrand = document.getElementById('data-co-brand').innerHTML;
const hubUrl = `${coBrand}hub`;
const resources = JSON.parse(
  document.getElementById('data-resources').innerHTML
);
const supportedProduct = data.supportedProduct;
const campaigns = data.campaigns;
const totalCampaignsItems = data.totalCampaignsItems;
const totalCampaignsPages = data.totalCampaignsPages;
const query = data.query;
const locale = JSON.parse(document.getElementById('data-locale').innerHTML);
const contentCountry = locale.country;
const mppFooter = data.mppFooter;
const mppHeader = data.mppHeader;
const allowedCharityType = data.allowedCharityType;
const isThisCharityTheirPreferred = data.isThisCharityTheirPreferred;
const showToastPreferredMessage = data.showToastPreferredMessage;
const authState = data.authState;
const userType = data.userType;
const unifiedLoginURL = data.unifiedLoginURL;
const isCountrySetPreferredSupported = data.isCountrySetPreferredSupported;
const cdnHost = data.cdnHost;
const domain = data.domain;
const elmo = data.elmo;
const dnwSdk = data.dnwSdk;

ReactDOM.render(
  <DataContext.Provider value={data}>
    <ThemeProvider theme={PAYPAL_THEME}>
      <Page
        {...charity}
        id={'nemo_npo'}
        supportedProduct={supportedProduct}
        charity={charity}
        campaigns={campaigns}
        totalCampaignsItems={totalCampaignsItems}
        totalCampaignsPages={totalCampaignsPages}
        query={query}
        donationInfo={donationInfo}
        states={states}
        csrf={csrf}
        fptiInfo={fptiInfo}
        coBrand={coBrand}
        amounts={amounts}
        hubUrl={hubUrl}
        resources={resources}
        mppFooter={mppFooter}
        mppHeader={mppHeader}
        unifiedLoginURL={unifiedLoginURL}
        userType={userType}
        isThisCharityTheirPreferred={isThisCharityTheirPreferred}
        showToastPreferredMessage={showToastPreferredMessage}
        authState={authState}
        isCountrySetPreferredSupported={isCountrySetPreferredSupported}
        cdnHost={cdnHost}
        domain={domain}
        contentCountry={contentCountry}
        elmo={elmo}
        dnwSdk={dnwSdk}
      />
    </ThemeProvider>
  </DataContext.Provider>,
  document.getElementById('page')
);
